"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUpFormBankId = require("./SignUpFormBankId.vue");

var _SignUpFormBankId2 = _interopRequireDefault(_SignUpFormBankId);

var _SignUpFormEmail = require("./SignUpFormEmail.vue");

var _SignUpFormEmail2 = _interopRequireDefault(_SignUpFormEmail);

var _ContactUs = require("./ContactUs");

var _ContactUs2 = _interopRequireDefault(_ContactUs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["project", "companies", "departments", "offices", "secret"],

  data: function data() {
    return {
      selectedComponent: "appSignUpFormBankId"
    };
  },


  components: {
    appSignUpFormBankId: _SignUpFormBankId2.default,
    appSignUpFormEmail: _SignUpFormEmail2.default,
    ContactUs: _ContactUs2.default
  },

  mounted: function mounted() {
    if (window.globals.flashMessage) {
      Event.fire("flash", {
        message: window.globals.flashMessage,
        level: window.globals.flashStatus
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/SignUpForm.vue
// module id = dO35
// module chunks = 0 1